import { Route } from "react-router-dom";

import {
  CREATE_CUSTOM_INVOICE,
  CREATE_GOVERNMENT_INVOICE,
  EDIT_CUSTOM_INVOICE,
  EDIT_GOVERNMENT_INVOICE,
  VIEW_CUSTOM_INVOICE,
} from "src/constants";
import { INVOICES_ROUTES } from "src/pages/invoices/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditCustomInvoice } from "./AddEditCustomInvoice";
import { AddEditGovernmentInvoice } from "./AddEditGovernmentInvoice.page";
import { CustomInvoiceList } from "./CustomInvoiceList";

/** Route tree for the invoices module, mounted under `/client/invoices` and `/invoices`. */
export const invoicesRoutes = (
  <>
    <Route
      path={INVOICES_ROUTES.governmentAdd}
      element={<ProtectedRoute permissions={CREATE_GOVERNMENT_INVOICE} component={AddEditGovernmentInvoice} />}
    />
    <Route
      path={INVOICES_ROUTES.governmentEdit}
      element={<ProtectedRoute permissions={EDIT_GOVERNMENT_INVOICE} component={AddEditGovernmentInvoice} />}
    />
    <Route path={INVOICES_ROUTES.root}>
      <Route index element={<ProtectedRoute permissions={VIEW_CUSTOM_INVOICE} component={CustomInvoiceList} />} />
      <Route
        path="create"
        element={<ProtectedRoute permissions={CREATE_CUSTOM_INVOICE} component={AddEditCustomInvoice} />}
      />
      <Route
        path=":id/edit"
        element={<ProtectedRoute permissions={EDIT_CUSTOM_INVOICE} component={AddEditCustomInvoice} />}
      />
    </Route>
  </>
);
